// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.routing-body {
    height: 100%;
    display: flex;
    flex-direction: column;
}

div.routing-buttonbar {
    flex: 0 0 auto;
}

div.routing-frame {
    border: 1px solid var(--border-color);
    padding: 0.25em;
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

div.routing-buttons {
    display: flex;
    align-items: center;
    position: relative;
    flex: 0 0 auto;
}

div.routing-buttons > div.ButtonBar {
    flex: 1 1 auto;
}

div.routing-buttons div.routing-settings-menu {
    position: absolute;
    left: 0;
    right: 0;
    top: calc(100% - 0.25em - 1px);
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid var(--border-color);
    background-color: var(--container-bg-color);
    box-shadow: 0px 0px 5px rgba(136, 136, 136, 1);
    z-index: 1;
    padding: 0.25em;
}

div.routing-tab-widget {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

div.routing-input {
    flex: 0 0 auto;
}

table.routing-settings-menu-entries td {
    white-space: nowrap;
}

table.routing-settings-menu-entries td:last-child > * {
    width: 100%;
}

div.routing-points {
    display: flex;
    align-items: center;
}

div.routing-points > div:first-child {
    flex: 1 1 auto;
}

div.routing-points > div:last-child {
    flex: 0 0 auto;
    margin-left: 0.25em;
}

div.routing-points-commands {
    margin: 0.25em 0;
    display: flex;
    align-items: center;
}

div.routing-points-commands > span.routing-points-commands-spacer {
    flex: 1 1 auto;
}

div.routing-points-commands > div.VectorLayerPicker {
    flex: 1 1 auto;
}

div.routing-search-field {
    display: flex;
    margin-bottom: 0.25em;
}

div.routing-search-field input.search-widget-input[type=text] {
    border: none;
    outline: none;
    height: calc(2em - 2px);
}

div.routing-search-field button.button {
    border-right: none;
    width: 2em;
}

button.routing-compute-button {
    width: 100%;
}

div.routing-status-failure {
    text-align: center;
    color: red;
    font-style: italic;
    padding: 0.25em;
}

div.routing-busy {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
}

div.routing-busy > div.spinner {
    width: 2em;
    height: 2em;
    margin-right: 0.25em;
}

div.routing-result {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

div.routing-result-summary {
    margin-top: 0.5em;
    border-top: 1px solid var(--border-color);
    padding: 0.25em;
    display: flex;
    align-items: center;
    flex: 0 0 auto;
}

div.routing-result-summary > span.icon {
    margin-right: 0.5em;
}

div.routing-result-summary > span.routing-result-spacer {
    flex: 1 1 auto;
}

div.routing-result-instructions {
    background-color: var(--input-bg-color);
    border-top: 1px solid var(--border-color);
    padding: 0.25em;
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: scroll;
    font-size: 90%;
}

div.routing-result-instruction {
    padding: 0.5em;
}

div.routing-result-instruction:hover {
    background-color: var(--list-item-bg-color-hover);
    color: var(--list-item-text-color-hover);
}

div.routing-result-instruction:not(:last-child) {
    border-bottom: 1px solid var(--border-color);
}

div.routing-result-instruction span.icon {
    margin-right: 0.5em;
}

div.routing-result-instruction-summary {
    padding: 0.25em;
    display: flex;
    align-items: center;
}

div.routing-result-instruction-summary > span.icon {
    margin-right: 0.5em;
}

div.routing-result-instruction-summary > span.routing-result-spacer {
    flex: 1 1 auto;
}

table.routing-iso-settings {
    width: 100%;
    white-space: nowrap;
}

table.routing-iso-settings td > input,
table.routing-iso-settings td > select {
    width: 100%;
}

input.routing-input-invalid {
    background-color: #FFAAAA!important;
}

div.routing-popup-button > button {
    width: 100%;
}

label.routing-import-button {
    position: relative;
    display: inline-block;
    cursor: pointer;
    color: var(--text-color-link);
}

label.routing-import-button:hover {
    text-decoration: underline;
}

label.routing-import-button > input {
    cursor: pointer;
    outline: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    overflow: hidden;
    opacity: 0;
}

div.routing-time-settings {
    padding: 0.5em 0;
    display: flex;
    align-items: center;
}

div.routing-time-settings > select {
    flex: 0 0 auto;
}

div.routing-time-settings > div {
    flex: 1 1 auto;
}
`, "",{"version":3,"sources":["webpack://./qwc2/plugins/style/Routing.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,cAAc;IACd,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,2CAA2C;IAC3C,8CAA8C;IAC9C,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,yCAAyC;IACzC,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uCAAuC;IACvC,yCAAyC;IACzC,eAAe;IACf,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iDAAiD;IACjD,wCAAwC;AAC5C;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB","sourcesContent":["div.routing-body {\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\ndiv.routing-buttonbar {\r\n    flex: 0 0 auto;\r\n}\r\n\r\ndiv.routing-frame {\r\n    border: 1px solid var(--border-color);\r\n    padding: 0.25em;\r\n    flex: 1 1 auto;\r\n    min-height: 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\ndiv.routing-buttons {\r\n    display: flex;\r\n    align-items: center;\r\n    position: relative;\r\n    flex: 0 0 auto;\r\n}\r\n\r\ndiv.routing-buttons > div.ButtonBar {\r\n    flex: 1 1 auto;\r\n}\r\n\r\ndiv.routing-buttons div.routing-settings-menu {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: calc(100% - 0.25em - 1px);\r\n    max-height: 200px;\r\n    overflow-y: auto;\r\n    border: 1px solid var(--border-color);\r\n    background-color: var(--container-bg-color);\r\n    box-shadow: 0px 0px 5px rgba(136, 136, 136, 1);\r\n    z-index: 1;\r\n    padding: 0.25em;\r\n}\r\n\r\ndiv.routing-tab-widget {\r\n    flex: 1 1 auto;\r\n    min-height: 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\ndiv.routing-input {\r\n    flex: 0 0 auto;\r\n}\r\n\r\ntable.routing-settings-menu-entries td {\r\n    white-space: nowrap;\r\n}\r\n\r\ntable.routing-settings-menu-entries td:last-child > * {\r\n    width: 100%;\r\n}\r\n\r\ndiv.routing-points {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\ndiv.routing-points > div:first-child {\r\n    flex: 1 1 auto;\r\n}\r\n\r\ndiv.routing-points > div:last-child {\r\n    flex: 0 0 auto;\r\n    margin-left: 0.25em;\r\n}\r\n\r\ndiv.routing-points-commands {\r\n    margin: 0.25em 0;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\ndiv.routing-points-commands > span.routing-points-commands-spacer {\r\n    flex: 1 1 auto;\r\n}\r\n\r\ndiv.routing-points-commands > div.VectorLayerPicker {\r\n    flex: 1 1 auto;\r\n}\r\n\r\ndiv.routing-search-field {\r\n    display: flex;\r\n    margin-bottom: 0.25em;\r\n}\r\n\r\ndiv.routing-search-field input.search-widget-input[type=text] {\r\n    border: none;\r\n    outline: none;\r\n    height: calc(2em - 2px);\r\n}\r\n\r\ndiv.routing-search-field button.button {\r\n    border-right: none;\r\n    width: 2em;\r\n}\r\n\r\nbutton.routing-compute-button {\r\n    width: 100%;\r\n}\r\n\r\ndiv.routing-status-failure {\r\n    text-align: center;\r\n    color: red;\r\n    font-style: italic;\r\n    padding: 0.25em;\r\n}\r\n\r\ndiv.routing-busy {\r\n    display: flex;\r\n    align-items: center;\r\n    flex: 0 0 auto;\r\n}\r\n\r\ndiv.routing-busy > div.spinner {\r\n    width: 2em;\r\n    height: 2em;\r\n    margin-right: 0.25em;\r\n}\r\n\r\ndiv.routing-result {\r\n    flex: 1 1 auto;\r\n    min-height: 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\ndiv.routing-result-summary {\r\n    margin-top: 0.5em;\r\n    border-top: 1px solid var(--border-color);\r\n    padding: 0.25em;\r\n    display: flex;\r\n    align-items: center;\r\n    flex: 0 0 auto;\r\n}\r\n\r\ndiv.routing-result-summary > span.icon {\r\n    margin-right: 0.5em;\r\n}\r\n\r\ndiv.routing-result-summary > span.routing-result-spacer {\r\n    flex: 1 1 auto;\r\n}\r\n\r\ndiv.routing-result-instructions {\r\n    background-color: var(--input-bg-color);\r\n    border-top: 1px solid var(--border-color);\r\n    padding: 0.25em;\r\n    flex: 1 1 auto;\r\n    min-height: 0;\r\n    overflow-y: scroll;\r\n    font-size: 90%;\r\n}\r\n\r\ndiv.routing-result-instruction {\r\n    padding: 0.5em;\r\n}\r\n\r\ndiv.routing-result-instruction:hover {\r\n    background-color: var(--list-item-bg-color-hover);\r\n    color: var(--list-item-text-color-hover);\r\n}\r\n\r\ndiv.routing-result-instruction:not(:last-child) {\r\n    border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\ndiv.routing-result-instruction span.icon {\r\n    margin-right: 0.5em;\r\n}\r\n\r\ndiv.routing-result-instruction-summary {\r\n    padding: 0.25em;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\ndiv.routing-result-instruction-summary > span.icon {\r\n    margin-right: 0.5em;\r\n}\r\n\r\ndiv.routing-result-instruction-summary > span.routing-result-spacer {\r\n    flex: 1 1 auto;\r\n}\r\n\r\ntable.routing-iso-settings {\r\n    width: 100%;\r\n    white-space: nowrap;\r\n}\r\n\r\ntable.routing-iso-settings td > input,\r\ntable.routing-iso-settings td > select {\r\n    width: 100%;\r\n}\r\n\r\ninput.routing-input-invalid {\r\n    background-color: #FFAAAA!important;\r\n}\r\n\r\ndiv.routing-popup-button > button {\r\n    width: 100%;\r\n}\r\n\r\nlabel.routing-import-button {\r\n    position: relative;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    color: var(--text-color-link);\r\n}\r\n\r\nlabel.routing-import-button:hover {\r\n    text-decoration: underline;\r\n}\r\n\r\nlabel.routing-import-button > input {\r\n    cursor: pointer;\r\n    outline: none;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 0;\r\n    height: 0;\r\n    overflow: hidden;\r\n    opacity: 0;\r\n}\r\n\r\ndiv.routing-time-settings {\r\n    padding: 0.5em 0;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\ndiv.routing-time-settings > select {\r\n    flex: 0 0 auto;\r\n}\r\n\r\ndiv.routing-time-settings > div {\r\n    flex: 1 1 auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
